import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyAnalyticsOptOut } from '../lib/analytics';

/**
 * Fires a Google Analytics 4 page_view event on every route change (SPA).
 * The initial pageview is already tracked by the gtag config in index.html.
 * Las visitas con sesión de administración quedan excluidas.
 */
export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Mantiene actualizado el flag oficial de GA4 en cada cambio de ruta.
    const optedOut = applyAnalyticsOptOut();
    if (optedOut || typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
